import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { defaultTo, path } from 'ramda';

import { toCurrency, snakeToTitle, validStripeId, getDiscountFromLineItems } from '../../util/helpers';
import { isNilOrEmpty } from '../../util/redux';

import Card from '../Card';

const propTypes = {
  admin: PropTypes.bool,
  transactions: PropTypes.array,
};

const PaymentTable = ({ admin, transactions, onClickReceipt }) => {
  return transactions.map((transaction) => {
    const discount = getDiscountFromLineItems(transaction.lineItems);
    const notes = path(['extra', 'notes'], transaction);

    // TODO: Make less hardcoded
    const isAfccCertification =
      path(['category', 'certificationId'], transaction) == 4 && path(['category', 'reportingPeriodId'], transaction);

    return (
      <Card className="mt-4" key={transaction.id}>
        <Card.Header className="text-capitalize">
          {moment(transaction.createdAt).format('MM/DD/YYYY')} - {snakeToTitle(transaction.type)}
          {notes !== undefined ? ' (Added by admin)' : ''}
          {admin && validStripeId(transaction.stripeId) && (
            <a
              className="btn btn-primary btn-sm float-right"
              href={`https://dashboard.stripe.com/payments/${transaction.stripeId}`}
              target="_blank"
            >
              View in Stripe
            </a>
          )}
          {onClickReceipt && !isAfccCertification && (
            <button className="btn btn-sm btn-primary float-right" onClick={() => onClickReceipt(transaction.id)}>
              View Receipt
            </button>
          )}
        </Card.Header>
        <Card.Body>
          {notes && (
            <Fragment>
              <h4>Admin Notes:</h4>
              <p>{notes}</p>
            </Fragment>
          )}
          {transaction.lineItems.length > 0 && (
            <Fragment>
              <h4>Line Items:</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {transaction.lineItems.map((payment) => {
                    const extra = defaultTo(path(['extra', 'due'], payment), path(['extra', 'year'], payment));

                    return (
                      <tr key={payment.id}>
                        <td>{`${payment.name}${extra ? ` (${extra})` : ''}`}</td>
                        <td>
                          {isAfccCertification ? (
                            <span className="badge badge-primary">Paid</span>
                          ) : (
                            toCurrency(payment.finalPrice)
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {!isNilOrEmpty(discount) && (
                    <tr>
                      <td>Discount Code: {discount.code}</td>
                      <td>{discount.percentage ? `-${discount.amount}%` : `-${toCurrency(discount.amount)}`}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Fragment>
          )}
          {!isAfccCertification && <h4>Total: {toCurrency(transaction.amount)}</h4>}
        </Card.Body>
      </Card>
    );
  });
};

PaymentTable.propTypes = propTypes;

export default PaymentTable;
